import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Cell } from '../../base/styled';

import {
  LabelWidget,
  NumberWidget,
  BarChartWidget,
} from '../../widgets';

const Playback = (props) => {

  const {
    title = '',
    playbackErrors: {
      error = null,
      data: {
        'rsdvr-playback-bar-chart': barChart = null,
        'rsdvr-playback-0-latest-count': latestCount0 = null,
        // 'rsdvr-playback-0-earlier-count': earlierCount0 = null,
        'rsdvr-playback-1-latest-count': latestCount1 = null,
        // 'rsdvr-playback-1-earlier-count': earlierCount1 = null,
        'rsdvr-playback-2-latest-count': latestCount2 = null,
        // 'rsdvr-playback-2-earlier-count': earlierCount2 = null,
        'rsdvr-playback-3-latest-count': latestCount3 = null,
        // 'rsdvr-playback-3-earlier-count': earlierCount3 = null,
        'rsdvr-playback-4-latest-count': latestCount4 = null,
        // 'rsdvr-playback-4-earlier-count': earlierCount4 = null,
      } = {},
    } = {},
    playbackGraph = null,
    playbackCount = null,
  } = props;

  const result = (
    <div className="dashboard">
      <Grid columns={5} rows="50px 1fr 200px 1fr" alignContent="stretch" height="inherit">
        <Cell width={5}>
          <LabelWidget input={{ data: { title } }} />
        </Cell>
        <Cell width={5}>
          <BarChartWidget input={{ error, data: barChart }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: latestCount0 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: latestCount1 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: latestCount2 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: latestCount3 }} />
        </Cell>
        <Cell>
          <NumberWidget input={{ error, data: latestCount4 }} />
        </Cell>
        <Cell width={4}>
          <BarChartWidget input={playbackGraph} />
        </Cell>
        <Cell>
          <NumberWidget input={playbackCount} />
        </Cell>
      </Grid>
    </div>
  );
  return result;
};

Playback.defaultProps = null;

Playback.propTypes = {
  title: PropTypes.string,
  playbackErrors: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      'rsdvr-playback-bar-chart': BarChartWidget.dataPropType,
      // 'rsdvr-playback-0-earlier-count': NumberWidget.dataPropType,
      'rsdvr-playback-0-latest-count': NumberWidget.dataPropType,
      // 'rsdvr-playback-1-earlier-count': NumberWidget.dataPropType,
      'rsdvr-playback-1-latest-count': NumberWidget.dataPropType,
      // 'rsdvr-playback-2-earlier-count': NumberWidget.dataPropType,
      'rsdvr-playback-2-latest-count': NumberWidget.dataPropType,
      // 'rsdvr-playback-3-earlier-count': NumberWidget.dataPropType,
      'rsdvr-playback-3-latest-count': NumberWidget.dataPropType,
      // 'rsdvr-playback-4-earlier-count': NumberWidget.dataPropType,
      'rsdvr-playback-4-latest-count': NumberWidget.dataPropType,
    }),
  }),
  playbackGraph: PropTypes.shape(BarChartWidget.propTypes),
  playbackCount: PropTypes.shape(NumberWidget.propTypes),
};

export default Playback;
